import { Component, h, Method, Prop, State } from '@stencil/core';

@Component({
  tag: 'input-text',
  shadow: false,
})
export class InputText {
  @Prop() name: string;
  @Prop() label: string;
  @Prop() value: string;
  @Prop() required: boolean;
  @Prop() type: string;
  @Prop() placeholder: string;
  @Prop() tooltip: string;
  @Prop() maxLength: number;
  @Prop() minLength: number;
  @Prop() pattern: string;
  @Prop() disabled: boolean;
  @Prop() dataTab: string;

  @State() data: string = '';

  @Method()
  async checkValidity(): Promise<boolean> {
    return this.data.trim().length > 0 || !this.required;
  }
  
  render() {
    return (
      <>
        <label-tooltip label={this.label} tooltip={this.tooltip}></label-tooltip>
        <input
          data-tab={this.dataTab}
          class="form-control-stencil form-control"
          type={this.type}
          name={this.name}
          required={this.required}
          value={this.value}
          placeholder={this.placeholder}
          maxLength={this.maxLength}
          minLength={this.minLength}
          pattern={this.pattern}
          disabled={this.disabled}
        />
      </>
    );
  }
}
